import {
  getLocalStorage,
  getPersistedResults,
  setLocalStorage,
  updatePersistedResults
} from "./localStorage";
import { getBundlePath } from "./cec";
import startsWithVowel from "./startsWithVowel";

export {
  getBundlePath,
  getLocalStorage,
  getPersistedResults,
  setLocalStorage,
  updatePersistedResults,
  startsWithVowel
};



// WEBPACK FOOTER //
// ./js/helpers/index.js